module.exports = __webpack_public_path__ + "img/map.90f5da17.png";